// Seed blog posts. Add more via this file.

export const BLOG_POSTS = [
  {
    slug: "first-time-buyer-guide-dfw",
    title: "The Honest First-Time Buyer Guide for DFW (2026)",
    excerpt: "Everything we wish every first-time DFW buyer knew before opening their first house tab. preapproval, neighborhoods, true cash-to-close, and the 8-stage transaction process.",
    publishedAt: "2026-01-15",
    author: "Torey Irving",
    readMinutes: 8,
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1600&q=80",
    body: `Buying your first home in DFW in 2026 is doable. but the process has more moving parts than most people expect.

## Step 1: Get preapproved (not pre-qualified)
Pre-qualification is a soft estimate. Preapproval is a hard credit pull with verified docs (W-2s, paystubs, bank statements) and carries real weight with sellers. In a competitive DFW market, sellers often won't consider an offer without one.

## Step 2: Know your real cash-to-close
On a $350K home, plan for ~$11K-$28K cash depending on your loan type:
- FHA (3.5% down + closing costs): ~$22K
- Conventional 5% down: ~$26K
- VA/USDA 0% down: just closing costs (~$11K)

## Step 3: Pick the right neighborhoods
Don't pick a "city". pick neighborhoods within cities. Fort Worth has 100+ neighborhoods with wildly different price points and vibes. Same for Dallas, Arlington, Plano. We'll narrow this down together based on your commute, schools, and lifestyle.

## Step 4: Make an offer + go under contract
A strong offer in DFW today usually includes:
- Earnest money (~1% of purchase price)
- Option fee (~$100-$500) for the inspection period
- A reasonable closing date (35-45 days)
- Minimal contingencies if you're competitive

## Step 5: The 8-stage transaction
Once under contract:
1. Under Contract. earnest money + schedule inspection
2. Option Period (~10 days). inspect + negotiate repairs
3. Appraisal Ordered. don't open new credit
4. Loan Processing. respond to lender same-day
5. Conditional Approval. final docs
6. Clear to Close. final walkthrough + wire instructions
7. Closing Day. sign, fund, get keys
8. Post-Closing. file homestead exemption by April 30

Want the full walkthrough? Ask Jason. he can answer questions specific to your situation 24/7.`,
  },
  {
    slug: "should-i-wait-for-rates",
    title: "Should I Wait for Rates to Drop? The Honest Answer",
    excerpt: "Waiting for lower mortgage rates feels smart, but it usually trades one cost for another. Here's how to think about it without getting paralyzed.",
    publishedAt: "2026-01-08",
    author: "Torey Irving",
    readMinutes: 5,
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1600&q=80",
    body: `Every buyer asks this. Here's the honest framework.

## The trade-off nobody talks about
When rates drop, two things happen:
1. Your monthly payment goes down ✅
2. Buyer competition goes up ❌. more bidders, faster bidding wars, less negotiation room

If rates drop 1% but home prices rise 5% (which they did the last three times rates dropped), you're worse off than buying today.

## What actually matters more than rates
- **Your timeline.** Are you ready in 90 days, or "someday"?
- **Your monthly comfort.** Can you afford the payment at today's rate? If yes. buy when you find the right home.
- **Your rent.** If you're paying $2,300/mo in rent, every month of waiting is $2,300 you'll never get back.
- **Inventory.** When rates drop, inventory dries up. sellers pull listings to wait for higher prices.

## The "marry the house, date the rate" rule
Buy the right home at today's rate. If rates drop later, refinance. You can change the rate. You can't change the house you missed.

That said. never buy stretched. If today's payment is uncomfortable, wait. Your financial peace matters more than any market timing.

Want to compare scenarios with your real numbers? Talk to a licensed lender. Torey can introduce you.`,
  },
  {
    slug: "selling-timeline-dfw",
    title: "How Long Will It Take to Sell My DFW Home in 2026?",
    excerpt: "Realistic listing-to-closing timelines for the DFW market right now, with a breakdown of what happens at each step.",
    publishedAt: "2025-12-20",
    author: "Torey Irving",
    readMinutes: 6,
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=1600&q=80",
    body: `Most well-priced DFW homes we list are under contract within 7-30 days. Closing adds another 30-45.

## Full timeline breakdown

### Days 0-7: Pre-list prep
- Comparative Market Analysis (CMA) finalized
- Pricing strategy decided
- Photos + drone + 3D tour scheduled
- Pre-list cleaning or staging if needed
- Listing paperwork signed

### Days 8-14: Live on MLS
- Listing goes live on NTREIS, syndicates to Zillow/Realtor/Redfin
- First open house weekend
- Showings ramp up

### Days 15-30: Negotiations
- Best offers usually come in first 2 weeks
- We review every offer with you. not just price, but financing strength, contingencies, closing timeline
- Under contract typically within 21 days for properly-priced homes

### Days 31-65: Under contract to closing
- Option period (~10 days): buyer inspects
- Appraisal ordered (~10 days)
- Loan processing (~14 days)
- Clear to close, final walkthrough, sign

## What slows it down
- Overpricing. kills momentum in the first 14 days. Recovery is hard.
- Repair surprises at inspection
- Appraisal coming in low
- Buyer financing issues

## What speeds it up
- Aggressive pricing within current comps
- Pre-listing inspection
- Professional photos + 3D tour
- Strong agent network (private MLS sharing before public)

Want a real net-proceeds estimate before listing? Book a 20-minute walkthrough with Torey at /contact.`,
  },
];

export function postBySlug(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug) || null;
}
